/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1PersonAttachmentAttachmentidDocument200,
  GetApiV1PersonAttachmentAttachmentidDocument401,
  GetApiV1PersonAttachmentAttachmentidDocument404,
  GetApiV1PersonAttachmentAttachmentidDocument500,
  GetApiV1PersonAttachmentAttachmentidDocumentPathParams,
  GetApiV1PersonAttachmentAttachmentidDocumentQueryParams,
  GetApiV1PersonAttachmentAttachmentidDocumentQueryResponse,
} from "../../types/personDocumentsController/GetApiV1PersonAttachmentAttachmentidDocument.ts";

export const getApiV1PersonAttachmentAttachmentidDocumentPathParamsSchema =
  z.object({
    attachmentId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1PersonAttachmentAttachmentidDocumentPathParams>;

export const getApiV1PersonAttachmentAttachmentidDocumentQueryParamsSchema =
  z.object({
    image: z.boolean().default(false),
    pdf: z.boolean().default(false),
  }) as unknown as ToZod<GetApiV1PersonAttachmentAttachmentidDocumentQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1PersonAttachmentAttachmentidDocument200Schema =
  z.any() as unknown as ToZod<GetApiV1PersonAttachmentAttachmentidDocument200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1PersonAttachmentAttachmentidDocument401Schema =
  z.any() as unknown as ToZod<GetApiV1PersonAttachmentAttachmentidDocument401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1PersonAttachmentAttachmentidDocument404Schema =
  z.any() as unknown as ToZod<GetApiV1PersonAttachmentAttachmentidDocument404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1PersonAttachmentAttachmentidDocument500Schema =
  z.any() as unknown as ToZod<GetApiV1PersonAttachmentAttachmentidDocument500>;

export const getApiV1PersonAttachmentAttachmentidDocumentQueryResponseSchema =
  z.lazy(
    () => getApiV1PersonAttachmentAttachmentidDocument200Schema,
  ) as unknown as ToZod<GetApiV1PersonAttachmentAttachmentidDocumentQueryResponse>;
